import personImageSrc from 'components/OnePageTemplates/mockData/personPhoto.jpg';

import { ReactComponent as MockLogoWhite } from '../mockData/mockLogoWhite.svg';

export const EXAMPLE_DOC_UK = {
  companyLogo: <MockLogoWhite />,
  companyName: 'Agrotech',
  projectBriefDescription:
    'Розробка холодостійкої пшениці, що включає дослідження, польові випробування, масштабування виробництва. Цільовий ринок: сільськогосподарський сектор, вирощування пшениці. Обґрунтування придбання: вирішення кліматичних проблем, забезпечення продовольчої безпеки.',
  lifeCycleStage: 'R&D',
  annualIncome: '$65,000,000',
  projectPaybackPeriod: '3 months',
  forecastedProfitability: '15%',
  fundingAmount: '$65,000,000',
  totalCost: '$65,000,000',
  percentageOfFunding: '30%',
  companyBriefDescription:
    'Провідна американська компанія з агробіотехнологій, що спеціалізується на дослідженні, розробці та комерціалізації інноваційних сортів зернових культур. Компанія зосереджується на наданні передових рішень для задоволення потреб фермерів та харчової промисловості загалом. Компанія використовує методи молекулярної біології для відбору та генетичної модифікації, щоб створити високопродуктивні сорти сільськогосподарських культур, які демонструють покращену врожайність, стійкість до хвороб та адаптивність до різноманітних умов навколишнього середовища.',
  operatingIndustry: 'Дослідження, розробка та комерціалізація інноваційних сортів зернових культур',
  registrationDate: '11.11.2002',
  numberOfEmployees: '150',
  mainGoals:
    'Розробка холодостійкої пшениці, інвестування в дослідження, масштабування виробництва, забезпечення сталого розвитку. Ключові стратегії: інвестиції в дослідження та розробку, розширення ринку, відстеження результатів.',
  strategyForAchievingGoals:
    "Розробка зернових культур із підвищеною холодостійкістю може дати фермерам більш стійкий та адаптивний сорт сільськогосподарських культур. Ці холодостійкі зернові будуть спеціально розроблені, щоб витримувати екстремально низькі температури, забезпечуючи кращі показники виживання та сталий ріст навіть у несприятливих зимових умовах. Цей технологічний прогрес має на меті пом'якшити вплив холоду на зернові культури, що зрештою сприятиме збільшенню врожайності, економічній стабільності фермерів та продовольчій безпеці країни.",
  mainProductsOrServices:
    'Спеціалізуючись на холодостійких сортах пшениці, компанія забезпечує фермерам доступ до стійких культур, що процвітають у суворих кліматичних умовах. Вона пропонує сорт пшениці 1, призначений для полів холодних кліматичних зон, та планує вивести сорт пшениці 2, з вищою холодостійкістю.',
  competitionAdvantage:
    'Розробка холодостійкої пшениці, що включає дослідження, польові випробування, масштабування виробництва. Цільовий ринок: сільськогосподарський сектор, вирощування пшениці. Обґрунтування придбання: вирішення кліматичних проблем, забезпечення продовольчої безпеки.',
  targetMarket:
    'Цільовий ринок складається з пшеничних ферм у Південній Дакоті та Північній Дакоті. У 2022 році Південна Дакота вирощувала 4 мільйони тонн, Північна Дакота – 4,2 мільйона тонн. Загальна ринкова вартість оцінюється в 103 мільярди доларів. 20 501 пшеничних ферм в Південній Дакоті, 21 003 у Північній Дакоті у 2022 році.',
  mainCompetitors:
    '120 компаній-постачальників конкурують на ринку пшениці. American AGRO лідирує з 15% часткою ринку. Інші конкуренти: EcoWheat, Grain Processing Corporation.',
  targetChannels:
    'Споживачі – 41 505 середніх та малих фермерів, що вирощують пшеницю в Південній Дакоті та Північній Дакоті. Характеристика фермерів: вік 20-50 років, керують малими та середніми фермами, шукають посухостійкі сорти пшениці та методи сталого ведення сільського господарства.',
  revenueStreams:
    "Основні джерела доходу включають продаж генетично модифікованого насіння сільськогосподарських культур, ліцензійні угоди на права інтелектуальної власності та консалтингові послуги з розвитку сільськогосподарських культур. Критичні фінансові припущення включають ринковий попит на високопродуктивні сорти, успішні результати досліджень та розробок, впровадження фермерами, отримання регуляторних схвалень та операційну ефективність. Ключовими партнерами є дослідницькі установи, сільськогосподарські асоціації, дистриб'ютори насіння та регуляторні органи для підтримки інновацій, охоплення ринку та дотримання вимог у галузі.",
  marketingStrategy:
    "Роздрібні торговці та кооперативи сільськогосподарської продукції, онлайн-платформи та електронна комерція, дистриб'ютори та оптовики насіння",
  projectStatus: ['Research and Development'],
  team: 'До основної команди проєкту входять: Едвард Ландо — генеральний директор, Навал Равікант — фінансовий директор, Фабріс Грінда — провідний науковий співробітник.',
  dynamics:
    'Сільськогосподарські угіддя щорічно збільшуються на 2 тисячі гектарів у Південній Дакоті та Північній Дакоті. Очікується, що розмір ринку зростатиме на 4% CAGR з 2022 по 2030 рік завдяки технологічному прогресу та регуляторній підтримці ГМО.',
  problemOfMarket:
    'На зерновому ринку США фермери стикаються зі значними викликами через негативний вплив дедалі більш непередбачуваних та суворих зимових погодних умов. Вразливість традиційних зернових культур до екстремальних холодів часто призводить до зниження врожайності, неврожаю та фінансових втрат для фермерів. Така холодна погода загрожує загальній стабільності та продуктивності зернового ринку США.',
  projectedAnnualIncome: '65000000',
  projectedAnnualProfit: '65000000',
  returnOnInvestment: '20',
  internalRateOfReturn: '25',
  teamMembers: [
    {
      fullName: 'Едвард Ландо',
      position: 'Генеральний директор',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Університет штату Оклахома, фінанси',
      workExperience:
        "Квітень 2017 р. — Травень 2020 р., ARP Dend, фінансовий менеджер\nРозробка та підтримка фінансових моделей для прогнозування фінансових показників компанії. Аналіз фінансових даних для отримання інформації про тенденції доходів, структуру витрат та прибутковість. Оцінка фінансових ризиків компанії та розробка стратегій для їх пом'якшення.",
      keySkills: 'Вирішення проблем',
      achievements:
        "Очолив вихід компанії на 12 нових ринків, що призвело до збільшення доходів на 40%",
    },
    {
      fullName: 'Едвард Ландо',
      position: 'Генеральний директор',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Університет штату Оклахома, фінанси',
      workExperience:
        "Квітень 2017 р. — Травень 2020 р., ARP Dend, фінансовий менеджер\nРозробка та підтримка фінансових моделей для прогнозування фінансових показників компанії. Аналіз фінансових даних для отримання інформації про тенденції доходів, структуру витрат та прибутковість. Оцінка фінансових ризиків компанії та розробка стратегій для їх пом'якшення.",
      keySkills: 'Вирішення проблем',
      achievements:
        "Очолив вихід компанії на 12 нових ринків, що призвело до збільшення доходів на 40%",
    },
    {
      fullName: 'Едвард Ландо',
      position: 'Генеральний директор',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Університет штату Оклахома, фінанси',
      workExperience:
        "Квітень 2017 р. — Травень 2020 р., ARP Dend, фінансовий менеджер\nРозробка та підтримка фінансових моделей для прогнозування фінансових показників компанії. Аналіз фінансових даних для отримання інформації про тенденції доходів, структуру витрат та прибутковість. Оцінка фінансових ризиків компанії та розробка стратегій для їх пом'якшення.",
      keySkills: 'Вирішення проблем',
      achievements:
        "Очолив вихід компанії на 12 нових ринків, що призвело до збільшення доходів на 40%",
    },
  ],
  contacts: {
    websiteUrl: 'agrotech.com',
    phone: '1(062)7266363',
    email: 'office@agrotech.com',
    fullNameWithPos: 'Джон Доу, генеральний директор',
    address: '699 Волнат-стріт, офіс 1800, Де-Мойн, Айова 50309, США.',
  },
  financingNeedsChart: {
    otherCost: { percentage: '8.333333333333332', currencyAmount: '50' },
    researchCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    equipmentCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    marketingCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    constructionCost: { percentage: '25', currencyAmount: '150' },
    workingCapitalCost: { percentage: '16.666666666666664', currencyAmount: '100' },
  },
  implementationPlanStages: [
    {
      stage: 'Планування досліджень та розробок',
      from: '2024-01-05T21:00:00.000Z',
      to: '2024-02-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Проведення початкового аналізу холодостійкості',
      from: '2024-02-05T21:00:00.000Z',
      to: '2024-03-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Розробка стратегій генетичної модифікації',
      from: '2024-03-05T21:00:00.000Z',
      to: '2024-05-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Вибір та закупівля насіння',
      from: '2024-04-05T21:00:00.000Z',
      to: '2024-08-05T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Створення тестових полів',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Посадка холодостійких сортів пшениці',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Аналіз результатів та їх уточнення',
      from: '2024-08-05T21:00:00.000Z',
      to: '2024-08-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Масштабування виробництва',
      from: '2024-09-05T21:00:00.000Z',
      to: '2024-10-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Розробка маркетингової стратегії',
      from: '2024-10-05T21:00:00.000Z',
      to: '2024-12-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Запуск продукту',
      from: '2024-12-05T21:00:00.000Z',
      to: '2024-12-25T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
  ],
};
